interface ParentConcernSectionProps {
  headerLine1: string
  headerLine2: string
  /** Title rows — `{plain}{highlighted}` per row (highlighted painted in primary) */
  titleRows: { plain: string; highlight: string }[]
  body: string
  emphasis: string
  imageUrl: string
  imageUrlMobile: string
  imageAlt: string
}

export function ParentConcernSection({
  headerLine1,
  headerLine2,
  titleRows,
  body,
  emphasis,
  imageUrl,
  imageUrlMobile,
  imageAlt,
}: ParentConcernSectionProps) {
  return (
    <section id="parent-concern" data-marketing-section="" className="w-full bg-qb-bg-tertiary py-14 lg:py-24 tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 flex flex-col gap-10 lg:gap-20 items-center">
        {/* Section header — Figma mobile (node 150:16902) is centered */}
        <div className="flex flex-col gap-1 lg:gap-2.5 items-center text-center font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
          <p className="text-qb-text-high whitespace-pre-line lg:whitespace-normal">
            {headerLine1}
          </p>
          <p className="text-qb-primary whitespace-pre-line lg:whitespace-normal">
            {headerLine2}
          </p>
        </div>

        {/* Contents */}
        <div data-testid="text-image-split" className="w-full flex flex-col lg:flex-row gap-10 lg:gap-0 items-center lg:items-center lg:justify-between">
          {/* Text block — Figma mobile (node 150:16906) centers all text; desktop reverts to left */}
          <div className="flex flex-col gap-6 lg:gap-10 items-center text-center lg:items-start lg:text-left">
            <div className="flex flex-col gap-2 lg:gap-1 font-bold text-[24px] lg:text-[32px] leading-[1.4] text-qb-text-high">
              {titleRows.map((row, i) => (
                <p key={i}>
                  <span>{row.plain}</span>
                  <span className="text-qb-primary">{row.highlight}</span>
                </p>
              ))}
            </div>
            <div className="flex flex-col gap-6">
              <p className="font-normal text-qb-text-mid text-[18px] lg:text-[20px] leading-[1.5] whitespace-pre-line">
                {body}
              </p>
              <p className="font-bold text-qb-text-high text-[20px] lg:text-[24px] leading-[1.5] lg:leading-[1.4] whitespace-pre-line">
                {emphasis}
              </p>
            </div>
          </div>

          {/* Review image */}
          <picture>
            <source media="(min-width: 1024px)" srcSet={imageUrl} />
            <img
              src={imageUrlMobile}
              alt={imageAlt}
              className="w-[312px] h-[226px] lg:w-[553px] lg:h-[401px] object-contain"
            />
          </picture>
        </div>
      </div>
    </section>
  )
}
